import styles from './styles.module.scss';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

import { Avatar } from '../../../Avatar/index.jsx';
import { Button } from '@cropler/ui-kit';

const DevicesWorkspacesList = ({ t, list = [], activeWorkspace, clickWorkspace, clickAddWorkspace }) => {
  return (
    <div className={styles.workspaces}>
      {list &&
        list.length > 0 &&
        list.map((item) => (
          <Button className={`${styles.workspacesItem} ${activeWorkspace === item.id ? styles.workspacesItemActive : ''}`} key={item.id} onClick={() => clickWorkspace(item.id)}>
            <Avatar imgUrl={item.avatar} alt={item.name} size={'small'} />
            <span className={styles.workspacesItemName}>{item.name}</span>
            {activeWorkspace === item.id && <CroplerIcon name="check"/>}
          </Button>
        ))}
      <Button className={styles.workspacesItem} onClick={() => clickAddWorkspace()}>
        <div className={styles.workspacesItemIcon}>
          <CroplerIcon name="add" />
        </div>
        <span className={styles.workspacesItemName}>{t('workspaces.buttonAddNew')}</span>
      </Button>
    </div>
  );
};

export default DevicesWorkspacesList;
